import { BaseModal, ModalResultType } from "../../core/modal/index";
import { Template, LazyTemplate } from "../../core/template/index";
import { ValtasiirtoBaseApp } from "../../app/valtaSiirtoBaseApp";
import Database from "../../app/db/index";
import { AttributeKey } from "../../core/db/models/attributes";
import { OrderItemAssignmentLike } from "../../app/db/models/orderItemAssignment";
import { ClientAction } from "../../app/synchronizer/index";
import { FaultCode } from "../../app/db/models/index";
import moment from 'moment';

export default class OrderItemOverviewModal extends BaseModal
{
    public template = Template.lazy('/modals/orderItemOverview/index.html');
    public app: ValtasiirtoBaseApp;

    public data: OrderItemOverviewViewData;

    constructor(assignment: OrderItemAssignmentLike)
    {
        super('Overview', '', assignment);
    }

    public beforeRender(): PromiseLike<void>
    {
        let startTime = moment(this.data.start_time);
        let endTime = moment(this.data.end_time);

        this.data._start_time = startTime.format('HH:mm');
        this.data._end_time = endTime.format('HH:mm');
        
        return this.app.db.FaultCode.toArray().then((faultCodes) =>
        {
            this.data.faultCodes = faultCodes;
        });
    }

    public afterRender(): PromiseLike<void>
    {
        return super.afterRender();
    }

    public formSubmitted(form: HTMLFormElement): PromiseLike<void>
    {
        this.app.setFormEnabled(form, false);
        let startTime = moment(this.data.start_time);
        let endTime = moment(this.data.end_time);
        let updatedStartTime = moment(this.data._start_time, 'HH:mm:ss');
        let updatedEndTime = moment(this.data._end_time, 'HH:mm:ss');
        
        startTime.hours(updatedStartTime.hours());
        startTime.minutes(updatedStartTime.minutes());
        startTime.seconds(updatedStartTime.seconds())        
        
        endTime.hours(updatedEndTime.hours());
        endTime.minutes(updatedEndTime.minutes());
        endTime.seconds(updatedEndTime.seconds());

        if (this.data.forceFaultCode && this.data.fault_code_id == null)
        {
            this.data.errorMessage = this.pgettext('Order item message', 'A fault code must be selected.');
            this.app.setFormEnabled(form, true);
        }
        else
        {
            return this.app.synchronizer.createMessageAndPull({
                action: ClientAction.ORDER_ITEM_UPDATE_INFO,
                data: {
                    start_time: startTime.toISOString(),
                    user_id: this.app.user.id,
                    end_time: endTime.toISOString(),
                    order_item_id: this.data.order_item_id,
                    extra_info: this.data.extra_info,
                    fault_code_id: this.data.fault_code_id
                }
            }).then(() =>
            {
                this.close(ModalResultType.SAVE);
            });
        }
    }

    public onCancelButtonClick(e: MouseEvent)
    {
        this.close(ModalResultType.CANCEL);
    }

    public onExrtaInfoFocus(e: Event)
    {
        console.log('onExrtaInfoFocus');
        setTimeout(() =>
        {
            console.log(e);
            (e.target as Element).scrollIntoView();
        }, 500);
    }
}

export interface OrderItemOverviewViewData extends OrderItemAssignmentLike
{
    faultCodes?: FaultCode[];
    forceFaultCode?: boolean;
    errorMessage?: string;
    _start_time?: string;
    _end_time?: string;
}